import * as yup from 'yup';

export const schema = yup.object().shape({
  name: yup.string().required('The name field is required.'),
  price: yup.number().required('The price field is required.').positive(),
  partNumber: yup.string().required('The part number field is required.'),
  isActive: yup.boolean(),
  description: yup.string()
});
